/* =====================================================================
   Bunch — B2G2 extras: upsell nudge, unclaimed-picks reminder, funnel
   analytics, preview-bar offset                          (added 2026-10-06)
   =====================================================================
   OPTIONAL LAYER. assets/bunch-b2g2.js owns the cart and the sheet; this file
   only listens to it (window.BunchB2G2 + bunch:b2g2:* events) and adds the
   things below. If this file 404s the page behaves exactly as before.

   1. UPSELL NUDGE. Once the 2 free picks are in the cart, a one-tap suggestion
      sits on the first row of the bottom rail: the next jar is 10% off (the
      store's automatic "10% off 5+ items" counts the 2 free picks, so it
      starts at the 3rd paid jar). It clicks the real card's Add button, so
      all cart logic stays in bunch-b2g2.js. Dismissal lasts the session.
      The copy never states a price: Shopify decides which two lines are the
      B2G2 buy lines, so we cannot promise which jar the 10% lands on.

   2. REMINDER. If the shopper closes the sheet without claiming, at 20s and
      60s (only if picks are still unclaimed) we toast and wiggle the gold rail
      button. Twice, then stop. If the tab is in the background when a
      reminder is due it is held and fires when they come back. A new browser
      session re-opens the sheet itself (bunch-b2g2.js, maybeOpenSheet).

   3. FUNNEL ANALYTICS. Custom events only, via gtag (GA4) and Meta Pixel
      trackCustom. Standard events (add_to_cart, begin_checkout, purchase) are
      deliberately NOT sent from here: Shopify's own pixels and GoKwik already
      send them and a second source would double-count.
      Steps: 1 page_view, 2 add_paid, 3 sheet_open, 4 claim, 5 checkout.

   4. PREVIEW-BAR OFFSET. In theme preview, Shopify pins a bar
      (#PBarNextFrameWrapper, about 68px) to the bottom of the screen. It sat
      on top of the rail's Checkout row, so a previewer saw only the nudge's
      Add button and no way to check out. We publish its height as
      --b2g2-bar-h and the rail, sheet and toast sit above it. On the live
      site there is no bar, the value is 0 and nothing moves.
   ===================================================================== */
(function () {
  'use strict';

  function start() {
    var api = window.BunchB2G2;
    var CFG = window.BUNCH_B2G2;
    if (!api || !CFG || api.extras) return;
    api.extras = true;

    var root = api.root;
    var state = api.state;
    var rail = root.querySelector('[data-b2g2-rail]');
    var sheet = root.querySelector('[data-b2g2-sheet]');
    var REQUIRED = CFG.requiredPaid || 2;
    var FREE_N = CFG.freeCount || 2;

    function sheetOpen() { return !!(sheet && sheet.hasAttribute('open')); }

    /* -------------------------------------------------- preview bar offset */
    function clearPreviewBar() {
      var bar = document.getElementById('PBarNextFrameWrapper');
      root.style.setProperty('--b2g2-bar-h', (bar ? bar.offsetHeight : 0) + 'px');
    }
    clearPreviewBar();
    // the bar is injected after load, so look again a few times
    [400, 1200, 3000, 6000].forEach(function (ms) { setTimeout(clearPreviewBar, ms); });
    window.addEventListener('resize', clearPreviewBar);

    /* ------------------------------------------------------- analytics */
    var STEP = { page_view: 1, add_paid: 2, sheet_open: 3, claim: 4, checkout: 5 };
    var META = {
      page_view: 'B2G2PageView',
      add_paid: 'B2G2AddPaid',
      sheet_open: 'B2G2SheetOpen',
      sheet_close: 'B2G2SheetClose',
      claim: 'B2G2Claim',
      checkout: 'B2G2CheckoutClick',
      tab: 'B2G2Tab',
      nudge_shown: 'B2G2NudgeShown',
      nudge_add: 'B2G2NudgeAdd',
      reminder: 'B2G2Reminder'
    };

    function send(name, detail) {
      var params = {
        funnel: 'b2g2',
        funnel_step: STEP[name] || 0,
        paid_items: state.paid,
        free_items: state.free,
        cart_value: Math.round((state.total || 0) / 100),
        currency: 'INR'
      };
      if (detail) {
        Object.keys(detail).forEach(function (k) {
          var v = detail[k];
          if (typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean') params[k] = v;
        });
      }
      try { if (typeof window.gtag === 'function') window.gtag('event', 'b2g2_' + name, params); } catch (e) { /* tracker blocked */ }
      try { if (typeof window.fbq === 'function') window.fbq('trackCustom', META[name] || 'B2G2Event', params); } catch (e) { /* tracker blocked */ }
    }

    // Events dispatched by bunch-b2g2.js. The nudge/reminder ones are sent below.
    ['add_paid', 'sheet_open', 'sheet_close', 'claim', 'checkout', 'tab'].forEach(function (name) {
      document.addEventListener('bunch:b2g2:' + name, function (e) { send(name, e.detail); });
    });

    var pageViewed = false;
    function pageView() {
      if (pageViewed) return;
      pageViewed = true;
      send('page_view', {});
    }

    /* ----------------------------------------------------- upsell nudge */
    var nudge = null;
    var nudgeOff = false;
    var shownTracked = false;
    var current = null;
    try { nudgeOff = sessionStorage.getItem('b2g2_nudge_off') === '1'; } catch (e) { /* private mode */ }

    function suggestion() {
      var cards = root.querySelectorAll('[data-b2g2-card]');
      for (var i = 0; i < cards.length; i++) {
        var c = cards[i];
        if (c.classList.contains('b2g2-card--picked')) continue;
        var add = c.querySelector('[data-b2g2-add]');
        if (add && !add.disabled) return c;
      }
      return null;
    }

    function build() {
      nudge = document.createElement('div');
      nudge.className = 'b2g2-nudge';
      nudge.hidden = true;
      nudge.innerHTML =
        '<img class="b2g2-nudge__img" alt="" width="40" height="40">' +
        '<div class="b2g2-nudge__txt"><b></b><span></span></div>' +
        '<button type="button" class="b2g2-nudge__add">+ Add</button>' +
        '<button type="button" class="b2g2-nudge__x" aria-label="Hide suggestion">×</button>';
      rail.insertBefore(nudge, rail.firstChild);

      nudge.addEventListener('click', function (event) {
        if (event.target.closest('.b2g2-nudge__x')) {
          nudgeOff = true;
          try { sessionStorage.setItem('b2g2_nudge_off', '1'); } catch (e) { /* private mode */ }
          update();
          return;
        }
        if (event.target.closest('.b2g2-nudge__add') && current) {
          var add = current.querySelector('[data-b2g2-add]');
          if (add && !add.disabled) {
            send('nudge_add', { variant: current.dataset.b2g2Variant });
            add.click();   // the real card button: bunch-b2g2.js does the cart write
          }
        }
      });
    }

    function update() {
      var show = !nudgeOff && state.paid >= REQUIRED && state.free >= FREE_N && !sheetOpen();
      current = show ? suggestion() : null;
      if (!current) {
        if (nudge) nudge.hidden = true;
        return;
      }
      if (!nudge) build();

      var img = current.querySelector('.b2g2-card__media img');
      var nImg = nudge.querySelector('img');
      if (img) {
        nImg.src = img.currentSrc || img.src;
        nImg.hidden = false;
      } else {
        nImg.hidden = true;
      }
      var title = current.querySelector('.b2g2-card__title');
      var price = current.querySelector('[data-b2g2-card-price]');
      nudge.querySelector('b').textContent = state.paid >= api.bonusPaid ? 'Add another — 10% off' : 'Your next jar is 10% off';
      nudge.querySelector('span').textContent =
        (title ? title.textContent.trim() : '') + (price ? ' · ' + price.textContent.trim() : '');
      nudge.hidden = false;

      if (!shownTracked) {
        shownTracked = true;
        send('nudge_shown', { variant: current.dataset.b2g2Variant });
      }
    }

    /* ---------------------------------------------------------- reminder */
    var timers = [];
    var owed = 0;   // a reminder that came due while the tab was in the background
    function clearTimers() {
      timers.forEach(clearTimeout);
      timers = [];
      owed = 0;
    }

    function pending() {
      return state.paid >= REQUIRED && state.free < FREE_N && !sheetOpen();
    }

    function remind(n) {
      if (!pending()) return;
      if (document.hidden) { owed = n; return; }   // fires when they come back
      owed = 0;
      api.toast('🎁 Your ' + FREE_N + ' free picks are still waiting — tap the gold button.');
      var cta = root.querySelector('[data-b2g2-rail-cta]');
      if (cta) {
        cta.classList.remove('b2g2-wiggle');
        void cta.offsetWidth;   // restart the animation
        cta.classList.add('b2g2-wiggle');
      }
      api.buzz();
      send('reminder', { n: n });
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden || !owed || !pending()) return;
      var n = owed;
      owed = 0;
      setTimeout(function () { remind(n); }, 800);
    });

    document.addEventListener('bunch:b2g2:sheet_close', function (e) {
      clearTimers();
      var reason = e.detail && e.detail.reason;
      if (reason !== 'claimed') {
        [20000, 60000].forEach(function (ms, i) {
          timers.push(setTimeout(function () { remind(i + 1); }, ms));
        });
      }
      update();
    });
    document.addEventListener('bunch:b2g2:claim', clearTimers);

    /* -------------------------------------------------------------- boot */
    document.addEventListener('bunch:b2g2:rendered', function () {
      pageView();
      update();
    });
    // Safety net if the first render happened before we were listening.
    setTimeout(function () { pageView(); update(); }, 2000);
  }

  if (window.BunchB2G2) {
    start();
  } else {
    document.addEventListener('bunch:b2g2:ready', start);
  }
})();